import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverRegistrationResponseDTO,
  DriverRequestDTO
} from '../../interfaces/apiInterfaces';

export class AddDriverCommand extends IRequestCommand<
  IAddDriver,
  ErrorDetails,
  IAddDriverCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'drivers';
}

export interface IAddDriverCommandParameters
  extends DriverRequestDTO,
  ICommandParameters { }

export interface IAddDriver
  extends DriverRegistrationResponseDTO,
  ICommandResponse { }
